// extracted by mini-css-extract-plugin
module.exports = {"root":"countdown-lp-module--root--ZSrtw","buttonWrapper":"countdown-lp-module--buttonWrapper--3Je8G"};